import React from "react";
import styles from "./style.module.css";
const DownloadButton = ({ icon, text, bgColor, textColor, width, height }) => {
  return (
    <button
      className={styles.button}
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <img
        src={icon}
        alt="Download Icon"
        className={styles.icon}
        style={{ width: width, height: height }}
      />
      <span className={styles.text}>{text}</span>
    </button>
  );
};

export default DownloadButton;
